import { render, staticRenderFns } from "./ISWCUpdate.vue?vue&type=template&id=225ac6bb&"
import script from "./ISWCUpdate.vue?vue&type=script&lang=js&"
export * from "./ISWCUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports